import { MaskService } from '../../../../../shared/services/mask.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-contas-pagar-previsao',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxCurrencyDirective,
  ],
  templateUrl: './contas-pagar-previsao.component.html',
  styleUrl: './contas-pagar-previsao.component.css',
})
export class ContasPagarPrevisaoComponent implements OnInit {
  @Input() parentForm!: FormGroup;
  @Input() currencyMask: any;

  get previsaoGroup(): FormGroup {
    return this.parentForm.get('previsao') as FormGroup;
  }

  constructor() {}

  ngOnInit(): void {}

  onDateInput(event: Event): void {
    MaskService.onDateInput(event, this.previsaoGroup.get('datetimePrevisao'));
  }
}
